// extracted by mini-css-extract-plugin
export default {"container":"ApplicationRequirementsContainer-module--container--fZYcX"};